const sendValuesToZaiusAndBoxever = (normalFields, selects) => {
  const inputValues = {};
  let optInConsent = false;

  normalFields.forEach(input => {
    if (input.getAttribute('data-sc-field-name') === 'OptInConsent') {
      optInConsent = input.checked;
    } else {
      Object.assign(inputValues, {
        [input.getAttribute('data-sc-field-name')]: input.value
      });
    }
  });

  const {
    email,
    firstName,
    lastName,
    phone,
    company,
    title,
    solution,
    industry
  } = inputValues;

  if (!email) return;

  sentParametersZaius(
    email,
    firstName,
    lastName,
    phone,
    company,
    industry,
    title,
    solution,
    optInConsent
  );
  sentParametersBoxever(email, firstName, lastName, phone);
};

const sentParametersZaius = async (
  email,
  first_name,
  last_name,
  phone,
  company,
  industry,
  job_title,
  area_of_interest,
  optInConsent = false
) => {
  if (!window.zaius) {
    console.warn('Zaius is not available');
    return;
  }
  await window.zaius.customer(
    {
      email
    },
    {
      first_name,
      last_name,
      phone,
      company,
      job_title,
      area_of_interest,
      industry
    }
  );
  await window.zaius.consent({
    consent: optInConsent,
    identifier_field_name: 'email',
    identifier_value: email
  });
  await window.zaius.event('account', { action: 'register' });
};

const sentParametersBoxever = async (email, firstName, lastName, phone) => {
  const eventIdentity = {
    channel: 'WEB',
    type: 'IDENTITY',
    language: 'EN',
    currency: 'USD',
    pos: window._boxever_settings.pointOfSale,
    browser_id: window.Boxever.getID(),
    guestType: 'customer',
    email,
    firstName,
    lastName,
    phone,
    identifiers: [
      {
        provider: 'email',
        id: email
      }
    ]
  };

  await window.Boxever.eventCreate(eventIdentity, () => {}, 'json');
};

const sendPageViewBoxever = async () => {
  const viewEvent = {
    browser_id: window.Boxever.getID(),
    channel: 'WEB',
    type: 'VIEW',
    language: 'EN',
    currency: 'USD',
    page: window.location.pathname,
    pos: window._boxever_settings.pointOfSale
  };

  await window.Boxever.eventCreate(viewEvent, () => {}, 'json');
};

export { sendValuesToZaiusAndBoxever, sendPageViewBoxever };
